<script setup>
import { Link } from '@inertiajs/vue3'
import { CircleCheck } from 'lucide-vue-next'
import { tutors } from '@/routes/index'

const features = [
  'Weekly tutoring',
  'Ongoing access',
  'Flexible and affordable'
]
</script>

<template>
  <section class="py-12 md:py-24 bg-gradient-to-br from-blue-600 to-purple-600">
    <div class="max-w-4xl mx-auto px-4 md:px-8 text-center">
      <h2 class="text-3xl md:text-4xl md:text-5xl font-bold text-white mb-6">
        Start learning with access that lasts beyond the lesson
      </h2>
      <p class="text-lg md:text-xl text-blue-100 mb-8 md:mb-10">
        Join thousands of students already learning smarter on Bindle
      </p>
      <Link :href="tutors()">
        <button class="bg-white text-blue-600 hover:bg-blue-50 transition-colors font-semibold text-lg px-10 py-4 rounded-xl shadow-xl cursor-pointer">
          Find a tutor
        </button>
      </Link>
      <div class="flex flex-wrap justify-center gap-8 mt-12 text-white">
        <div
          v-for="feature in features"
          :key="feature"
          class="flex items-center space-x-2"
        >
          <CircleCheck class="w-5 h-5" />
          <span>{{ feature }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
